import React from "react";
import "./footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-logo">
        <img src="/sari_kolsi_logo.jpg" alt="Logo" />
      </div>
       <a 
      href="https://www.facebook.com/lakiasiaintoimistosarikolsi/?locale=fi_FI"
      target="_blank" rel="noopener noreferrer">
        <i className="fab fa-facebook"></i>
      </a>
      
      <div className="footer-text">
        <p>
          lakiasiat@sarikolsi.fi <br />
          044-7772797 <br />
          <br>
          </br>
          Vääksyntie 4, Vääksy <br />
          Vapaudenkatu 8, Lahti
        </p>
      </div>
      



     
    </footer>
  );
}

export default Footer;
